<div>
  <app-productos-lista></app-productos-lista>
</div>
